import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import {
  CommodityOfferLayoutType,
  CommodityOfferContent,
} from '../../commodity-offers.model';
import { CommodityOfferCardComponent } from '../../commodity-offer-card/commodity-offer-card.component';
import { CommodityOfferEDHeaderComponent } from '../../partials/ed/commodity-offer-header/commodity-offer-header.component';
import { CommodityOfferPriceTagComponent } from '../../partials/shared/commodity-offer-price-tag/commodity-offer-price-tag.component';
import { CommodityOfferAccordionComponent } from '../../commodity-offer-accordion/commodity-offer-accordion.component';
import { CommodityOfferPriceBreakdownComponent } from '../../partials/shared/commodity-price-breakdown/commodity-price-breakdown.component';
import { CommodityVerticalOfferDropdownComponent } from '../../partials/ed/commodity-vertical-offer-dropdown/commodity-vertical-offer-dropdown.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ed-consumer-retention-commodity-offer',
  templateUrl: './ed-consumer-retention-commodity-offer.component.html',
  standalone: true,
  imports: [
    CommodityOfferCardComponent,
    CommodityOfferEDHeaderComponent,
    CommodityOfferPriceTagComponent,
    CommodityOfferAccordionComponent,
    CommodityOfferPriceBreakdownComponent,
    CommodityVerticalOfferDropdownComponent,
    AutomationIdDirective,
    CSCaptureDirective,
    CommonModule,
  ],
})
export class EdConsumerRetentionCommodityOfferComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() variant?: CommodityOfferLayoutType;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() active = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showLoadingState = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showTariffs = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() selectableOffer = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() enableNewOfferCardTitles? = false;

  @Output() openMoreInfo = new EventEmitter<void>();
  @Output() viewTariffModal = new EventEmitter<void>();
  @Output() selectOffer = new EventEmitter<void>();
  @Output() openTariffDropdown = new EventEmitter<void>();
  @Output() closeTariffDropdown = new EventEmitter<void>();
}
